'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export const Redirect: React.FC<{ to: string; replace?: boolean }> = ({
  to,
  replace,
}) => {
  const router = useRouter()

  useEffect(() => {
    if (replace) {
      router.replace(to)
    } else {
      router.push(to)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
